import * as api from "Api";

class CollaboratorApi {
  getCollaboratorPerformances(idOrganization, collaboratorId, year) {
    return api.getCollaboratorPerformances({
      organization: idOrganization,
      id: collaboratorId,
      year: year
    });
  }

  getCollaboratorClientFolders(
    idOrganization,
    userId,
    collaborator,
    roleCollaborator,
    space,
    year,
    synchro,
    loggedAs,
    filterCRMTypes,
    filterCRMGroupes,
    filterJuridicalForm,
    searchedValue,
    clientIds
  ) {
    return api.getCollaboratorFolders({
      organization: idOrganization,
      id: userId,
      space: space,
      filterCollaborator: collaborator,
      roleCollaborator: roleCollaborator,
      year: year,
      synchro: synchro,
      loggedAs: loggedAs,
      filterCRMTypes: filterCRMTypes,
      filterCRMGroupes: filterCRMGroupes,
      filterJuridicalForm: filterJuridicalForm,
      searchedValue: searchedValue,
      clientIds: clientIds
    });
  }

  getCollaboratorPresentations(
    idOrganization,
    collaboratorId,
    year,
    word,
    synchro
  ) {
    return api.getCollaboratorPresentations({
      organization: idOrganization,
      id: collaboratorId,
      word: word,
      year: year,
      synchro: synchro
    });
  }

  getCollaboratorAllPresentations(idOrganization, collaboratorId) {
    return api.getCollaboratorAllPresentations({
      organization: idOrganization,
      id: collaboratorId
    });
  }

  getCollaboratorByIdOrApiId(idOrganization, id, apiId) {
    return api.getCollaboratorByIdOrApiId({
      organization: idOrganization,
      apiId: apiId,
      id: id
    });
  }

  getCollaborators(uen, keyWord) {
    return api.getCollaborators({ uen: uen, searchWord: keyWord });
  }

  fetchTaskByCollaborator(collaboratorId, owner) {
    return api.fetchLastTaskByUser({
      collaboratorId: collaboratorId,
      owner: owner
    });
  }

  uploadIcsFile(icsFile) {
    return api.saveIcsFile({
      icsFile: icsFile
    });
  }
}

export default new CollaboratorApi();



// WEBPACK FOOTER //
// ./src/services/CollaboratorServices.js